import { modularScale } from 'polished';
import styled from 'styled-components';

const Separator = styled.div`
  background-color: ${props => props.theme.colors.nearWhite};
  height: 3px;
  width: ${props => props.width || 80}%;
  margin: ${modularScale(3)} 0;
`;

export default Separator;
